import axios from '@/plugins/axios'
import { Module } from 'vuex'

const clearbitModule: Module<any, any> = {
    state: {},

    actions: {
        async getCompanySuggestions({ commit }, query) {
            let data = null
            const url =
                'https://web.api.socialhp.com/autocomplete/all/' +
                query

            await axios
                .get(url, { withCredentials: false })
                .then((response) => {
                    data = response.data
                })

            return data
        },
    },

    mutations: {},
}

export default clearbitModule
